<template>
  <div>
    <div class="top">缴费记录</div>
    <div class="contaa jh-page">
      <div v-if="datalist.length > 0">
        <div v-for="item in datalist" :key="item.id" class="record-card jh-card">
          <van-cell
            :title="item.title"
            :label="item.validTime"
            class="single"
            :border="false"
            ><span class="price">￥{{ item.totalFee }}</span></van-cell
          >
          <div class="mignxi"><span>缴费明细:</span></div>
          <div v-for="ele in item.orderItems" :key="ele.id" class="one">
            <span>{{ ele.itemName }}</span>
            <span class="oneprice"
              >￥{{ (ele.price / 100).toFixed(2) }}</span
            >
          </div>
          <div class="zhifut">
            <div class="left">
              <img
                src="../../assets/iconimg/suc.png"
                alt=""
                v-if="item.orderPayStatus == 2"
              />
              <img src="../../assets/iconimg/err.png" alt="" v-else />
              <div class="spana">{{ statusText(item.orderPayStatus) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-wrap jh-card">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datalist: [],
    };
  },

  mounted() {
    this.getdata();
  },

  methods: {
    statusText(status) {
      const map = {
        0: "待支付",
        2: "支付成功",
        50: "支付错误",
        42: "需要退款",
        41: "完成退款",
        43: "部分退款",
        40: "微信退款中",
      };
      return map[status] || "订单取消";
    },
    getdata() {
      this.fetchget("/api/app/order/myList").then((res) => {
        if (res) {
          res.items.forEach((item) => {
            item.validTime = this.$moment(item.validTime).format(
              "YYYY-MM-DD HH:mm"
            );
            item.totalFee = (item.totalFee / 100).toFixed(2);
          });
          this.datalist = res.items;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$brand: #dd0000;
$bg: #f3f5f9;
$text: #0f172a;
$muted: #64748b;
$border: #e2e8f0;
$radius: 10px;
$shadow: 0 4px 16px rgba(15, 23, 42, 0.06);

.top {
  width: 100%;
  height: 44px;
  background-color: $brand;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}

.jh-page {
  min-height: calc(100vh - 44px);
  padding: 14px;
  background: $bg;
  box-sizing: border-box;
}

.jh-card {
  background: #fff;
  border-radius: $radius;
  border: 1px solid $border;
  box-shadow: $shadow;
  overflow: hidden;
}

.contaa {
  overflow-y: auto;
}

.record-card {
  margin-bottom: 12px;
}

.single {
  color: $text;
  font-size: 14px;
  font-weight: 600;
}

.price {
  color: $brand;
  font-size: 14px;
  font-weight: 600;
}

.one {
  background-color: #ffffff;
  line-height: 30px;
  color: $text;
  font-size: 12px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;

  .oneprice {
    color: $muted;
  }
}

.mignxi {
  background-color: #ffffff;
  line-height: 40px;
  color: $text;
  font-size: 14px;
  padding: 0 16px;
  font-weight: 600;
}

.zhifut {
  border-top: 1px solid $border;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;

  .left {
    display: flex;
    align-items: center;

    img {
      height: 20px;
      width: 20px;
    }

    .spana {
      font-size: 12px;
      margin-left: 6px;
      color: #475569;
    }
  }
}

.empty-wrap {
  padding: 24px 0;
}
</style>
